import React from "react";
import Input from "antd/lib/input";
import Icon from "antd/lib/icon";
import { mutateData } from "../actions.js";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const Data = props => {
  return (
    <Input
      className={
        props.blockIndex === 0
          ? "genesis-data genesis-mutate genesis-mutate-2"
          : ""
      }
      style={{ marginBottom: "20px" }}
      prefix={<Icon type="file-text" />}
      addonBefore={
        <span style={{ marginRight: "7px", marginLeft: "7px" }}>DATA</span>
      }
      defaultValue={props.data}
      onChange={e => {      
          props.mutateData(props.peer, props.blockIndex, e.target.value)
        }
      }
    />
  );
};

Data.propTypes = {
  data: PropTypes.string,
  mutateData: PropTypes.func,
  blockIndex: PropTypes.number
};

// peer, blockIndex, transactionIndex, outputIndex, address

function mapDispatchToProps(dispatch) {
  return {
    mutateData: (peer, blockIndex, data) => {
      console.log(peer, blockIndex, data);
      dispatch(mutateData(peer, blockIndex, data));
    }
  };
}

const DataContainer = connect(null, mapDispatchToProps)(Data);

export default DataContainer;



// WEBPACK FOOTER //
// ./src/Block/Data.js